import gql from "graphql-tag";
import { invoiceFragment } from "../invoice/fragments";
import { orderFragment, recurringOrderFragment } from "./fragments";

export const GET_ORDER = gql`
  query order($id: ID!) {
    order(id: $id) {
      ...OrderFragment
      showDetailsOnInvoice
      notes
      legalNotice
      isFirstOrder
      invoiced
      orderLines {
        id
        projectRoleName
        quantity
        hourlyRate
        unit
      }
      company {
        id
        name
      }
    }
  }
  ${orderFragment}
`;

export const GET_RECURRING_ORDER = gql`
  query recurringOrder($id: ID!) {
    recurringOrder(id: $id) {
      ...RecurringOrderFragment
      showDetailsOnInvoice
      paymentOption
      notes
      legalNotice
      isFirstOrder
      orderLines {
        id
        projectRoleName
        quantity
        hourlyRate
        unit
      }
      company {
        id
        name
      }
    }
  }
  ${recurringOrderFragment}
`;

export const GET_ORDERS_AND_INVOICES = gql`
  query ordersAndInvoices($projectId: ID!, $date: Date!) {
    ordersAndInvoices(projectId: $projectId, date: $date) {
      ... on Order {
        ...OrderFragment
      }
      ... on Invoice {
        ...InvoiceFragment
        company {
          id
          name
        }
        linkedResource {
          ... on Order {
            id
          }
        }
      }
    }
  }
  ${orderFragment}
  ${invoiceFragment}
`;

export const GET_USER_ORDERS = gql`
  query userOrders(
    $startDate: Date!
    $endDate: Date!
    $offset: Int = 0
    $limit: Int = 5
  ) {
    userOrders(
      offset: $offset
      limit: $limit
      filter: { startDate: $startDate, endDate: $endDate }
    ) {
      hasMore
      items {
        id
        title
        startDate
        endDate
        status
        price
        orderLines {
          id
          projectRoleName
          unit
          quantity
          hourlyRate
        }
        project {
          id
          name
        }
      }
    }
  }
`;

export const GET_UPCOMING_USER_ORDERS = gql`
  query userOrders(
    $startDate: Date!
    $endDate: Date!
    $offset: Int = 0
    $limit: Int = 5
  ) {
    userOrders(
      offset: $offset
      limit: $limit
      filter: { startDate: $startDate, endDate: $endDate }
    ) {
      hasMore
      items {
        id
        title
        startDate
        endDate
        status
        project {
          id
        }
      }
    }
  }
`;

export const GET_UPCOMING_USER_RECURRING_ORDERS = gql`
  query userRecurringOrders(
    $startDate: Date!
    $endDate: Date!
    $offset: Int = 0
    $limit: Int = 5
  ) {
    userRecurringOrders(
      offset: $offset
      limit: $limit
      filter: { startDate: $startDate, endDate: $endDate }
    ) {
      hasMore
      items {
        id
        title
        startDate
        endDate
        status
        project {
          id
        }
      }
    }
  }
`;

export const ORDERS_TO_REJECT_IF_RECURRING_CANCELED = gql`
  query ordersToRejectIfRecurringCanceled($recurringOrderId: ID!) {
    ordersToRejectIfRecurringCanceled(id: $recurringOrderId) {
      id
      title
      startDate
      endDate
      status
    }
  }
`;

export const GET_SIGNED_ORDER = gql`
  query signedOrder($token: String!) {
    signedOrder(token: $token) {
      status
      error
      data {
        id
        title
        notes
        projectId
        projectName
        status
        startDate
        endDate
        dueDate
        price
        paymentOption
        companyName
        orderLines {
          projectRoleName
          hourlyRate
          quantity
          unit
        }
        legalNotice
        requiresLegalNoticeAgreement
        canApprove
      }
    }
  }
`;

export const GET_SIGNED_RECURRING_ORDER = gql`
  query signedRecurringOrder($token: String!) {
    signedRecurringOrder(token: $token) {
      status
      error
      data {
        id
        title
        notes
        projectId
        projectName
        companyName
        status
        startDate
        endDate
        price
        paymentOption
        orderLines {
          projectRoleName
          hourlyRate
          quantity
          unit
        }
        legalNotice
        requiresLegalNoticeAgreement
        canApprove
      }
    }
  }
`;
